var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_573_29)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C21.7323 0 28 6.26773 28 14C28 21.7323 21.7323 28 14 28C6.26773 28 0 21.7323 0 14C0 6.26773 6.26773 0 14 0Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88688 8.71631C12.805 8.71631 15.1708 11.0821 15.1708 14.0002C15.1708 16.9183 12.805 19.2841 9.88688 19.2841C6.9693 19.2841 4.60352 16.9183 4.60352 14.0002C4.60352 11.0821 6.9693 8.71631 9.88688 8.71631ZM22.4639 9.55084C22.9785 9.55084 23.3952 11.5431 23.3952 14.0002C23.3952 16.4573 22.9785 18.4496 22.4639 18.4496C21.9498 18.4496 21.5326 16.4573 21.5326 14.0002C21.5326 11.5431 21.9498 9.55084 22.4639 9.55084ZM18.3416 9.13357C19.8181 9.13357 21.0147 11.3123 21.0147 14.0002C21.0147 16.6881 19.8181 18.8669 18.3416 18.8669C16.865 18.8669 15.6679 16.6881 15.6679 14.0002C15.6679 11.3123 16.865 9.13357 18.3416 9.13357Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_573_29"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.5d17f78836ec9642939eb3b0dde7328a.svg";
export { ForwardRef as ReactComponent };